import { Component, Output, EventEmitter, OnInit, Input, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Service } from './ctl-gys-tahsil-ana-arama.service';
import { DxButtonModule } from 'devextreme-angular';
import { ColumnModel } from '@dabnet-kamu/libs/ui';
import { DkDxDataCtlTableComponent } from '../../../dk-dx-data-ctl-table/dk-dx-data-ctl-tablecomponent';
import { DlistDto } from '@dabnet-kamu/libs/ui';
import { Observable } from 'rxjs';

import { OrtakService } from '@dabnet-kamu/libs/ui';
import { CommonModule } from '@angular/common';
import {GysTahsilAnaControlService} from "../ctl-gys-tahsil-ana.service";


@Component({
  selector: 'dk-ctl-gys-tahsil-ana-arama',
  standalone: true,
  imports: [DkDxDataCtlTableComponent, DxButtonModule,CommonModule],
  providers: [Service],
  templateUrl: './ctl-gys-tahsil-ana-arama.component.html',
  styleUrls: ['./ctl-gys-tahsil-ana-arama.component.scss'],
})
export class CtlGysTahsilAnaAramaComponent implements OnInit   {
  private destroyRef = inject(DestroyRef);
  public data: any;
  public columns: ColumnModel[];
  public selectedData: any = null;
  gridControlsList$: Observable<DlistDto>;
  @Input() control: any;
  @Output() private closePopup = new EventEmitter<string>();
  constructor(
    private service: Service,
    private gysTahsilAnaControlService:GysTahsilAnaControlService,
    public ortakService:OrtakService
  ) {

  }

  ngOnInit(): void {
    this.data = this.service.getData(this.control);
    this.gridControlsList$ = this.gysTahsilAnaControlService.gridControlsList$;
    this.gysTahsilAnaControlService.gridControlsList$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x=>{
      this.columns = this.ortakService.setRecursiveFieldData([x],false);
      })

  }

  focusChanged(e: any) {
    this.selectedData = e.row;
  }

  
  onKeyDown(e: any) {
  if (e.event?.key === 'Enter') {
      this.closePopup.emit(this.selectedData);
    }
  }
  
  dblClickRow(e:any){
    this.closePopup.emit(e);
  }

  chooseBtnClick() {
    this.closePopup.emit(this.selectedData);
  }

  cancelBtnClick() {
    this.closePopup.emit(null);
  }
}

